module.exports = __webpack_public_path__ + "static/casella-family-499970d7c50db8dd16c2714a4b30fd80.jpg";